import { Avatar } from "@mui/material";
import React from "react";

const UserWidget = ({ value, outlet }) => {
  return value ? (
    <div className="d-flex g-15 a-center mb-5 mt-5">
      <Avatar className="bg-primary" src={value.photo || ""}>
        {(value?.fullName).substring(0, 2)}
      </Avatar>
      <div className="d-grid">
        <span className="">{value?.fullName}</span>
        {outlet && <span className="fs-12">{outlet.outletName}</span>}
      </div>
    </div>
  ) : (
    ""
  );
};

export default UserWidget;
